import { createModalController } from '../shared/modal-controller';

createModalController({
    popupSelector: '.LegalNote',
    modalInnerSelector: '.LegalNote__inner',
    openTriggerSelector: '#open-legal-note',
    closeTriggerSelector: ['.LegalNote__continue', '.LegalNote__close'],
    initialFocusSelector: '.LegalNote__close',
    lockScroll: true,
});
